import { AbstractEntity } from "../AbstractEntity";
import ProtocolType from "../protocol/ProtocolType";
import ProtocolTypeGroup from "../protocol/ProtocolTypeGroup";
import { ACCESS_TO_BOOK_ROLE_PREFIX, HEAD_OF_BOOK_ROLE_PREFIX, } from "../usercontrol/Role";
export function getHeadOfBookRoleName(book) {
    return `${HEAD_OF_BOOK_ROLE_PREFIX}${book.technicalName}`;
}
export function getAccessToBookRoleName(book) {
    return `${ACCESS_TO_BOOK_ROLE_PREFIX}${book.technicalName}`;
}
export function isHeadOfBookRole(role) {
    return role.name.startsWith(HEAD_OF_BOOK_ROLE_PREFIX);
}
export function isAccessToBookRole(role) {
    return role.name.startsWith(ACCESS_TO_BOOK_ROLE_PREFIX);
}
export function getBookForRole(role, books) {
    return isHeadOfBookRole(role)
        ? books.find((book) => book.secondApprovalRole._id === role._id)
        : books.find((book) => book.accessToBookRole?._id === role._id);
}
export default class Book extends AbstractEntity {
    name;
    technicalName;
    icon;
    groupsAndTypes = [];
    documentation = [];
    displayVoyageInExports = false;
    displayNavigationRecordsSeparatlyInExports = false;
    splitPdfExportByDays = false;
    secondApprovalRole;
    accessToBookRole;
    confidential;
    constructor(book = {}) {
        super();
        Object.assign(this, book);
    }
}
//# sourceMappingURL=Book.js.map